<template>
  <div class="inspector-selector">
    <SubHeader>Inspector</SubHeader>
    <p v-if="singleInspector" class="inspector-selector--inspector">
      {{singleInspector}}
    </p>
    <v-select
      v-else
      :items="inspectorItems"
      :value="selectedInspectorId"
      class="inspector-selector--select"
      name="selectedInspector"
      outline
      solo
      @change="updateInspector" />
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader.vue';

export default {
  components: {
    SubHeader,
  },
  props: {
    inspectors: {
      name: 'inspectors',
      type: Array,
      default: () => [],
    },
    selectedInspector: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    inspectorItems() {
      return [
        {
          text: 'No Preference / All Inspectors',
          value: 0,
        },
        ...this.inspectors.map(inspector => ({
          text: `${inspector.givenName} ${inspector.familyName}`,
          value: inspector.legacyId,
        })),
      ];
    },
    selectedInspectorId() {
      return this.selectedInspector
        ? this.selectedInspector.legacyId
        : 0;
    },
    singleInspector() {
      return (this.inspectors.length === 1)
        ? `${this.inspectors[0].givenName} ${this.inspectors[0].familyName}`
        : null;
    },
  },
  methods: {
    updateInspector(inspectorId) {
      this.$emit('change', inspectorId);
    },
  },
};
</script>
